// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

import Endpoints from "../Endpoints";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## Sale Get
/**
 *
 * @param {{params: object, query: { customerId: string, mrId: string, employeeId: string, productName: string, productIds: string, regionId: string, payType: string, saleTimeFilter: string, searchQuery: string, paymentType: string, saleType: string, planId: string, date: string, page: number, limit: number, saleSearchQueryType: "Customer" | "Sale" }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const version = localStorage.getItem("version");
  // for v1
  if (version === "v1") option.query.parasutAccountId = option.query.companyId;

  const response = await $api.get(Endpoints.Sale.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};

// ## Sale Change Status
/**
 *
 * @param {{"id": "string","saleType": "Offer","saleDate": "2024-08-06T13:13:30.542Z"}} form
 *
 * @returns
 */
export const ChangeStatus = async (form) => {
  const response = await $api.post(Endpoints.Sale.ChangeStatus(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Sale Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.Sale.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Sale Update Sale
/**
 *
 * @param {{"saleId": "string"}} form
 
 * @returns
 */
export const UpdateSale = async (form) => {
  const response = await $api.post(Endpoints.Sale.UpdateSale(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export const UpdateSaleDate = async (form) => {
  const response = await $api.post(Endpoints.Sale.UpdateSaleDate(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * @typedef {Object} SaleCheckoutQuantityInfoDto
 * @property {string} guid
 * @property {boolean} isExtraProduct
 * @property {boolean} canBeExtraProduct
 */

/**
 * @typedef {Object} SaleCheckoutPackageInfoDto
 * @property {string} name
 * @property {number} price
 */

/**
 * @typedef {Object} SaleCheckoutBasketItemDto
 * @property {string} code
 * @property {string} image
 * @property {boolean} applyDiscount
 * @property {string} productId
 * @property {string} productName
 * @property {string} productCategoryName
 * @property {string} brandName
 * @property {string} serviceCode
 * @property {number} stockCount
 * @property {number} price
 * @property {SaleCheckoutQuantityInfoDto[]} quantityInfos
 * @property {number} quantity
 * @property {string} extraProductRuleId
 * @property {string} createdDate
 * @property {SaleCheckoutPackageInfoDto} packageInfo
 * @property {boolean} [isExpense]
 */

/**
 * @typedef {Object} SaleCheckoutRuleBasketDto
 * @property {string} extraRuleId
 * @property {string} extraRuleDescription
 * @property {SaleCheckoutBasketItemDto[]} basketItems
 */

/**
 * @typedef {Object} UpdateCheckoutDto
 * @property {string} saleId
 * @property {string} checkoutId
 * @property {SaleCheckoutBasketItemDto[]} baskets
 * @property {SaleCheckoutRuleBasketDto[]} ruleBaskets
 */

/**
 *
 * @param {UpdateCheckoutDto} form
 * @returns
 */
export const UpdateCheckout = async (form) => {
  const response = await $api.post(Endpoints.Sale.UpdateCheckout(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * Yeni ödeme planı snapshot'larında paymentPlanId ve installmentNumber birlikte
 * gönderilmelidir. Legacy satırlar operationDate + price ile eşleşmeye devam eder.
 * @param {{ saleId: string, operationDate: string, price: number, paymentDate?: string, paymentPlanId?: string, installmentNumber?: number }} form
 * @returns
 */
export const UpdatePay = async (form) => {
  const response = await $api.post(Endpoints.Sale.UpdatePay(), form);
  if (response?.success === true || response?.isSuccess === true) {
    return { ...response, message: response.message || "OK", isSuccess: true };
  }
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export const UpdateParasutInvoiceId = async (option) => {
  const response = await $api.post(
    Endpoints.Sale.UpdateParasutInvoiceId(option),
    {}
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * Manuel moddaki satış için müşteri borç planı (checkoutPays) oluşturur.
 * Plan ve taksit kimlikleri, yeni kayıtlarda sunucu tarafından üretilir; istemci
 * yalnızca manuel vade/tutar seçimlerini gönderir.
 * @param {{
 *   saleId: string,
 *   checkoutPays: Array<{
 *     price: number,
 *     paymentType: string,
 *     paymentDate: string | null,
 *     operationDate: string
 *   }>,
 *   description?: string
 * }} form
 */
export const CreateManualDebt = async (form) => {
  const response = await $api.post(Endpoints.Sale.CreateManualDebt(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * Eksik checkout finansal snapshot alanlarını backfill kuyruğuna alır (Admin).
 */
export const BackfillCheckoutFinancialSnapshots = async () => {
  const response = await $api.post(
    Endpoints.Sale.BackfillCheckoutFinancialSnapshots(),
    {}
  );
  if (response?.result === "OK" && response?.isSuccess !== false) {
    return { ...response, message: "OK", isSuccess: true };
  }
  return { message: "FAIL", isSuccess: false, data: null };
};

export default {
  GetAll,
  ChangeStatus,
  GetById,
  UpdateSale,
  UpdateSaleDate,
  UpdateCheckout,
  UpdatePay,
  UpdateParasutInvoiceId,
  CreateManualDebt,
  BackfillCheckoutFinancialSnapshots,
};
